var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVehiculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.113,
    height: 15.134,
    viewBox: "0 0 26.113 15.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2918",
    "data-name": "Group 2918",
    transform: "translate(0.75 0.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M474.462,145.6v-2.2l6.24.472s3.434.056,4.086,1.37c0,0,2.37-2.913,8.169-.067,0,0-1.825,6.121-4.564,6.121h-5.1S480.611,145.6,474.462,145.6Z",
    transform: "translate(-474.462 -141.623)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_836",
    "data-name": "Line 836",
    x2: 9.772,
    transform: "translate(7.058 6.822)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M503.779,139.921s3.1-.765,3.866,1.731,3.1,8.658,3.1,8.658",
    transform: "translate(-489.284 -139.81)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_619",
    "data-name": "Ellipse 619",
    cx: 3.071,
    cy: 3.071,
    rx: 3.071,
    ry: 3.071,
    transform: "translate(0.068 7.412)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_620",
    "data-name": "Ellipse 620",
    cx: 1.054,
    cy: 1.054,
    rx: 1.054,
    ry: 1.054,
    transform: "translate(2.085 9.429)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_621",
    "data-name": "Ellipse 621",
    cx: 3.071,
    cy: 3.071,
    rx: 3.071,
    ry: 3.071,
    transform: "translate(18.471 7.412)",
    fill: "none",
    stroke: "#66d02d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_622",
    "data-name": "Ellipse 622",
    cx: 1.054,
    cy: 1.054,
    rx: 1.054,
    ry: 1.054,
    transform: "translate(20.488 9.429)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M510.229,139.927a1.879,1.879,0,1,1,1.3,3.525Z",
    transform: "translate(-492.545 -139.81)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehiculo);
export default __webpack_public_path__ + "static/media/icon_vehiculo.74ed097b374e62e670b2552ae14de444.svg";
export { ForwardRef as ReactComponent };